(function () {
  const ENABLED = theme.settings.size0000GiftEnabled;
  const GIFT_VARIANT_ID = theme.settings.size0000GiftVariantId;
  const PROPERTY_KEY = '_size_0000_gift';

  console.log('TEST:: Size 0000 gift opt-in init', { enabled: ENABLED, variantId: GIFT_VARIANT_ID });

  if (!ENABLED || !GIFT_VARIANT_ID) {
    console.log('TEST:: Size 0000 gift opt-in disabled — missing config');
    return;
  }

  function getCartDrawerInfo() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return null;
    const section = cartDrawer.closest('.shopify-section');
    if (!section) return null;
    const sectionId = section.id.replace('shopify-section-', '');
    return { cartDrawer, sectionId };
  }

  function getSectionsParam() {
    const info = getCartDrawerInfo();
    if (!info) return 'cart-icon-bubble';
    return 'cart-icon-bubble,' + info.sectionId;
  }

  function setBlocking(isBlocking) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.toggle('pointer-events-none', isBlocking);
      drawer.setAttribute('aria-busy', isBlocking ? 'true' : 'false');
    }
    document.querySelectorAll('size-0000-gift-opt-in').forEach((el) => {
      el.setAttribute('aria-busy', isBlocking ? 'true' : 'false');
    });
  }

  function updateCartUI(data) {
    const info = getCartDrawerInfo();
    if (info && typeof info.cartDrawer.renderContents === 'function') {
      info.cartDrawer.renderContents(data, false);
    } else {
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl && data.sections && data.sections['cart-icon-bubble']) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = data.sections['cart-icon-bubble'];
        const newContent = tmpl.content.querySelector('.shopify-section');
        if (newContent) bubbleEl.innerHTML = newContent.innerHTML;
      }
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  }

  async function addGift() {
    console.log('TEST:: Size 0000 gift — adding (opt-in)');
    setBlocking(true);
    try {
      const addUrl = window.Shopify.routes.root + 'cart/add.js';
      const resp = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { [PROPERTY_KEY]: true }
          }],
          sections: getSectionsParam(),
          sections_url: window.location.pathname
        })
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error('Size 0000 gift add failed: ' + (data.description || data.message || resp.status));
      updateCartUI(data);
    } finally {
      setBlocking(false);
    }
  }

  async function removeGift(lineKey) {
    if (!lineKey) {
      console.log('TEST:: Size 0000 gift — removeGift called without a line key, aborting');
      return;
    }
    console.log('TEST:: Size 0000 gift — removing (opt-in)');
    setBlocking(true);
    try {
      const resp = await fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: getSectionsParam(),
          sections_url: window.location.pathname
        })
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error('Size 0000 gift remove failed: ' + (data.description || data.message || resp.status));
      updateCartUI(data);
    } finally {
      setBlocking(false);
    }
  }

  class Size0000GiftOptIn extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-reconcile-remove')) {
        const lineKey = this.dataset.giftLineKey;
        removeGift(lineKey);
        return;
      }

      this.checkbox = this.querySelector('.js-size-0000-gift-toggle');
      if (!this.checkbox) return;

      this.handleChange = this.handleChange.bind(this);
      this.checkbox.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      if (this.checkbox && this.handleChange) {
        this.checkbox.removeEventListener('change', this.handleChange);
      }
    }

    async handleChange(evt) {
      const checked = evt.target.checked;
      this.checkbox.disabled = true;
      try {
        if (checked) {
          await addGift();
        } else {
          await removeGift(this.dataset.giftLineKey);
        }
      } catch (error) {
        console.log('TEST:: Size 0000 gift opt-in change failed', error);
        this.checkbox.checked = !checked;
      } finally {
        this.checkbox.disabled = false;
      }
    }
  }

  if (!customElements.get('size-0000-gift-opt-in')) {
    customElements.define('size-0000-gift-opt-in', Size0000GiftOptIn);
  }
})();
